import CircularProgress from "../../../components/CircularProgress"
import { twMerge } from "tailwind-merge";
import { ACHIEVEMENT_STATUS } from "../utils/constant";
import { BadgeImage } from "./BadgeImage";

export function BadgeView({ title, data }: { title: string, data?: any }) {
    const { pct_complete, status, badge_icon_url } = data || {};
    const isComplete = status === ACHIEVEMENT_STATUS.EARNED;
    return (
        <div className={twMerge("py-2 px-4 flex flex-col gap-1 max-w-[150px]")}>
            <CircularProgress 
                radius={40} 
                percentage={isComplete ? 100 : (pct_complete || 0)} 
                containerClassName="flex items-center justify-center" 
                customText={<BadgeImage iconUrl={badge_icon_url} alt={title} />} 
                color={{
                    progressBg: "#E4E4E7",
                    progress: "var(--primary)",
                    text: "var(--primary)",
                }} 
            />
            <div className="text-xs text-black min-w-[108px] text-center">{title}</div>
        </div>
    )
}